export default Object.freeze({
  'family': "Mam ustalone prawo do renty rodzinnej",
  'social': "Mam przyznaną rentę socialną",
  'disabled': "Mam orzeczenie stopnia niepełnosprawności"
})
